// extracted by mini-css-extract-plugin
export default {"signup-form":"Signup_signup-form__PhOa+","form-type":"Signup_form-type__KQi+r","Errors":"Signup_Errors__mvqFF"};